import { humanize } from 'components/SchemaForm/schemaUtils';
import translations from 'i18n/translations';
import { formatDateTime } from 'services/utils';

// Payment providers already have a display name; other integrations (Sumsub) fall back to the code
export const getProviderLabel = (i18n, provider) =>
  translations.en?.[`paymentProvider.${provider}`]
    ? i18n.getMessage(`paymentProvider.${provider}`)
    : humanize(provider);

export const getSettingLabel = (settingKey) => humanize(settingKey);

export const getSettingChangeText = (i18n, { updatedAt, updatedBy }, getOperatorName) =>
  updatedAt
    ? i18n.getMessage('settings.integrations.meta.updated', {
        date: formatDateTime(updatedAt),
        operator: getOperatorName(updatedBy)
      })
    : i18n.getMessage('settings.integrations.meta.neverChanged');
